@if (!readonly) {
  <div class="w-full">
    <h3>Agregar adjuntos</h3>
    <p class="font-thin italic">
      * Formatos soportados: *.jpg *.png *.jpeg *.pdf *.docx
      <cite></cite>
    </p>
    @if (!multiple ? archivos.length == 0 : true) {
      <div
        class="flex pt-5 pb-5 justify-center items-center"
        animate.enter="fade-slide-enter"
        animate.leave="fade-slide-leave"
      >
        <div
          class="h-14 px-3 border border-primary-900 text-primary-900 cursor-pointer flex justify-center items-center transition-all duration-300 hover:bg-primary-900 hover:text-white mr-4"
          (click)="file.click()"
        >
          <p>
            <i class="pi-cloud-upload pi"></i>
            Subir archivo
          </p>
        </div>
        <input
          hidden
          type="file"
          #file
          (change)="uploadFile($event)"
          accept="image/jpg, image/png, image/gif, image/jpeg, .pdf, .docx"
        />
      </div>
    }
  </div>
  <div class="w-full hide" [ngClass]="{ show: archivos.length > 0 }">
    <div>
      <div class="pt-2 grid grid-cols-12 gap-5">
        @for (archivo of archivos; track $index) {
          <div
            class="lg:col-span-4 md:col-span-6 sm:col-span-12 col-span-12 flex justify-start items-center"
          >
            <div class="w-16 h-full relative flex justify-center items-center">
              @if (esImagen(archivo)) {
                <p-image
                  id="image"
                  [src]="archivo.base64 ? archivo.base64 : 'svg/no-file.svg'"
                  alt="Image"
                  width="64"
                  [preview]="true"
                  class="rounded-lg"
                  appendTo="body"
                />
              } @else {
                <img
                  [src]="toggleImagen(archivo)"
                  alt="Image"
                  width="64"
                  class="rounded-lg"
                />
              }
            </div>
            <div class="pl-3 w-full">
              <p class="m-0 p-0">
                {{
                  archivo ? archivo.nombre : 'No se selecciono ningún archivo'
                }}
              </p>
              <c-input
                [(valor)]="archivo.descripcion"
                placeholder="Ingrese descripción"
                etiqueta="Descripción"
              />
            </div>
            <div>
              <img
                pTooltip="Quitar"
                src="svg/close.svg"
                alt="Cerrar"
                width="30"
                class="ml-2 cursor-pointer img-spin"
                (click)="eliminarArchivo($index)"
              />
            </div>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="w-full">
    <div class="grid grid-cols-12 gap-5">
      @for (archivo of archivos; track $index) {
        <div
          class="lg:col-span-4 md:col-span-6 sm:col-span-12 col-span-12 flex justify-start items-center"
        >
          <div class="relative group mr-2">
            @if (esImagen(archivo)) {
              <p-image
                [src]="archivo.base64 ? archivo.base64 : 'svg/no-file.svg'"
                alt="Image"
                width="64"
                [preview]="true"
                class="rounded-lg"
                appendTo="body"
              />
              <div
                class="absolute top-0 left-0 w-16 h-16 bg-black/40 rounded-lg pointer-events-none opacity-0 group-hover:opacity-100 transition-all duration-500"
              ></div>
            } @else {
              <img
                [src]="toggleImagen(archivo)"
                alt="Image"
                width="64"
                class="rounded-lg cursor-pointer"
                (click)="
                  isPdf(archivo.nombre)
                    ? pdf.show(archivo.base64)
                    : openInWindow(archivo.base64)
                "
              />
            }
          </div>
          <div class="w-full pl-2">
            <p class="m-0 p-0">
              {{ archivo ? archivo.nombre : 'No se selecciono ningún archivo' }}
            </p>
            <c-input
              [valor]="archivo?.descripcion ?? 'Sin descripción'"
              etiqueta="Descripción"
              placeholder="Inserte una descripción"
              [readonly]="true"
            />
          </div>
        </div>
      } @empty {
        <div class="col-span-12">
          <p class="text-black italic font-bold text-center">Sin adjuntos</p>
        </div>
      }
    </div>
  </div>
}

<c-pdf-viewer #pdf />
